import { all, put, takeLatest } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import * as actionTypes from './action-types'
import * as userActionTypes from '../auth/action-types'

function* errorSaga({ payload: { error } }) {
  const status = error?.status
  const statusString = status ? status.toString() : ''

  if (status === 401) {
    yield put({ type: userActionTypes.LOGOUT })
  } else if (statusString.startsWith('4')) {
    yield put(push('/404'))
  } else {
    yield put(push('/500'))
  }
}

export default function* rootSaga() {
  yield all([takeLatest(actionTypes.ERROR, errorSaga)])
}
